export var FieldNames;
(function (FieldNames) {
})(FieldNames || (FieldNames = {}));
